export const routes = [
  {
    path: "/",
    label: "Home",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/products",
    label: "Products",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/products/:productURLType",
    label: "ProductId",
    breadcrumbParam: "productURLType",
    hideBreadcrumb: true,
    isVirtual: true,
  },
  {
    path: "/admin/products/:productURLType/:productId",
    label: "ProductId",
    breadcrumbParam: "productId",
  },
  {
    path: "/patients",
    label: "Patients",
    hideBreadcrumb: true,
  },
  {
    path: "/patients/:patientId",
    label: "Patients Id",
    breadcrumbParam: "patientId",
    breadcrumb: ({ patient }) => (patient?.firstName ? `${patient?.firstName} ${patient?.lastName ?? ""}` : "Patient"),
    breadcrumbResolver: "patient",
  },
  {
    path: "/admin/patients",
    label: "Patients",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/patients/:patientId",
    label: "Patients Id",
    breadcrumbParam: "patientId",
  },
  {
    path: "/patients/:patientId/assessment",
    label: "Assessment",
    isVirtual: true,
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId",
    label: "Id",
    breadcrumbParam: "assessmentId",
    breadcrumb: ({ assessment }) => (assessment?.title ? `${assessment?.title}` : "Assessment ID"),
    breadcrumbResolver: "assessment",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/mergewoundassessment",
    label: "Merge Wound Assessment",
  },
  {
    path: "/patients/:patientId/assessment/:assessmentId/transferwoundassessment",
    label: "Transfer Wound Assessment",
  },
  {
    path: "/admin/customers",
    label: "Customers",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/customers/:customerId",
    label: "Id",
    breadcrumbParam: "customerId",
    breadcrumb: ({ customer }) => (customer?.customerName ?? "Customer"),
    breadcrumbResolver: "customer",
  },
  {
    path: "/admin/users",
    label: "Users",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/users/:userId",
    label: "Id",
    breadcrumbParam: "userId",
    breadcrumb: ({ user }) => (user?.firstName ? `${user?.firstName} ${user?.lastName ?? ""}` : "User Name"),
    breadcrumbResolver: "user",
  },
  {
    path: "/admin/sso",
    label: "Sso",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/sso/:ssoId",
    label: "Id",
    breadcrumbParam: "ssoId",
    breadcrumb: ({ sso }) => (sso?.domainName ?? "Domain"),
    breadcrumbResolver: "sso",
  },
  {
    path: "/admin/FormBuilder",
    label: "Form Builder",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/FormBuilder/:formId",
    label: "Id",
    breadcrumbParam: "formId",
    breadcrumb: ({ form }) => (form?.name ?? "Layout Name"),
    breadcrumbResolver: "form",
  },
  {
    path: "/content",
    label: "HomeContentViewer",
    hideBreadcrumb: true,
  },
  {
    path: "/home",
    label: "Skin Health",
    hideBreadcrumb: true,
  },
  {
    path: "/worklist",
    label: "WorkList",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/announcement",
    label: "Announcement",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/announcement/:id",
    label: "Id",
    breadcrumbParam: "id",
  },
  {
    path: "/admin/layouts",
    label: "Layouts",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/layouts/:layoutId",
    label: "Id",
    breadcrumbParam: "layoutId",
    breadcrumb: ({ layout }) => (layout?.name ?? "Layout Name"),
    breadcrumbResolver: "layout",
  },
  {
    path: "/admin/support",
    label: "Contextual Support",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/support/:supportDataId",
    label: "Id",
    breadcrumbParam: "supportDataId",
    breadcrumb: ({ support }) => (support?.topic ?? "Topic"),
    breadcrumbResolver: "support",
  },
  {
    path: "/userprofile",
    label: "User Profile",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/formulary",
    label: "Formulary",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/formulary/:formularyId",
    label: "View Single Formulary",
    breadcrumbParam: "formularyId",
    breadcrumb: ({ formulary }) => (formulary?.data?.formularyName ?? "Formulary Name"),
    breadcrumbResolver: "formulary",
  },
  {
    path: "/woundReport",
    label: "Wound Report",
    hideBreadcrumb: true,
  },
  {
    path: "/woundReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/woundReport/activewoundsnotresolved",
    label: "Active Wounds Not Resolved",
  },
  {
    path: "/woundReport/patientwithactivewounds",
    label: "Patient With Active Wounds",
  },
  {
    path: "/biReports",
    label: "BI Reports",
    hideBreadcrumb: true,
  },
  {
    path: "/biReports/biReportsList",
    label: "BI Reports List",
  },
  {
    path: "/treatmentReport",
    label: "Treatment Report",
    hideBreadcrumb: true,
  },
  {
    path: "/treatmentReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/qualityReport",
    label: "Quality Report",
    hideBreadcrumb: true,
  },
  {
    path: "/qualityReport/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/qualityReport/pendingphotos",
    label: "Missing Photos",
  },
  {
    path: "/qualityReport/pendingassessments",
    label: "Assessments not signed",
  },
  {
    path: "/qualityReport/pendingreviews",
    label: "Assessments not locked",
  },
  {
    path: "/qualityReport/completedassessments",
    label: "Completed Assessments",
  },
  {
    path: "/platformanalytics",
    label: "Platform Analytics",
    hideBreadcrumb: true,
  },
  {
    path: "/platformanalytics/pdfdownload",
    label: "Download PDF",
  },
  {
    path: "/admin/surveyResult",
    label: "Survey",
    hideBreadcrumb: true,
  },
  {
    path: "/admin/usageAnalytics",
    label: "Usage Analytics",
    hideBreadcrumb: true,
  },
  {
    path: "/unAuthorized",
    label: "UnAuthorized Content",
    hideBreadcrumb: true,
  },
  {
    path: "/learnMore",
    label: "Learn More",
    hideBreadcrumb: true,
  },
];
